import { Br } from "@/components/molecules/Br";

export const AiSecurityAdvisory = () => {
  return (
    <div className="col-span-1 space-y-4 md:space-y-6">
      <div className="space-y-4 px-6 py-2 sm:px-8 md:px-12 md:py-4 lg:py-5">
        <div className="space-y-3">
          <h3 className="font-bold text-pri fluid-text-[18px,26px]">
            AI駆動開発向けセキュリティアドバイザリー
          </h3>
          <p className="font-bold text-ter fluid-text-[14px,18px]">
            AI駆動開発の安全性を、
            <Br sp />
            プロの視点で継続サポート
          </p>
        </div>
        <div className="space-y-4 leading-comfort text-txt-base fluid-text-[14px,18px]">
          <p>
            AI駆動開発のナレッジと、高セキュリティ・ミッションクリティカルな
            <Br sp />
            システム構築で培った知見を活かし、セキュリティ観点でのアドバイスを
            <Br sp />
            サブスクリプション形式で提供。お客様の内製開発を支援します。
          </p>
          <div className="space-y-2">
            <h4 className="font-bold text-ter fluid-text-[13px,17px]">
              3つのサービス内容
            </h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>定期ミーティング</strong>：月1回/1時間程度。開発状況のヒアリング、セキュリティ対応の確認、最新トピックスの共有
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>継続サポート</strong>：お客様状況を把握した上での問い合わせ対応（月5件まで）
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>セキュリティチェック観点提供</strong>：システムアーキテクチャやリスクを踏まえた「AIにチェックさせるべき確認観点」をご提供
                </span>
              </li>
            </ul>
          </div>
          <a
            href="https://solution.tocca.systems/solutions/ai-security-advisory"
            target="_blank"
            rel="noopener noreferrer"
            className="block rounded-lg bg-bgc-dark p-4 md:p-5 transition-opacity hover:opacity-80"
          >
            <p className="text-center font-bold text-pri fluid-text-[13px,17px]">
              詳しくはこちら（ソリューションサイト）
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};
